import { createAction } from "typesafe-actions";

export const setItemAlertModalOpen = createAction(
  "@item-alert-modal/setItemAlertModalOpen"
)<boolean>();
